import { BUSINESS } from "@/data/business";

const ORIGIN = typeof window !== "undefined" ? window.location.origin : "";

export const organizationSchema = () => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: BUSINESS.name,
  url: ORIGIN,
  email: BUSINESS.email,
  telephone: BUSINESS.phoneRaw,
  address: {
    "@type": "PostalAddress",
    addressLocality: BUSINESS.city,
    addressRegion: "VIC",
    addressCountry: "AU",
  },
});

export const websiteSchema = () => ({
  "@context": "https://schema.org",
  "@type": "WebSite",
  name: BUSINESS.name,
  url: ORIGIN,
});

export const localBusinessSchema = () => ({
  "@context": "https://schema.org",
  "@type": ["LocalBusiness", "CleaningService"],
  name: BUSINESS.name,
  image: `${ORIGIN}/og-image.jpg`,
  url: ORIGIN,
  telephone: BUSINESS.phoneRaw,
  email: BUSINESS.email,
  priceRange: "$$",
  address: {
    "@type": "PostalAddress",
    addressLocality: BUSINESS.city,
    addressRegion: "VIC",
    addressCountry: "AU",
  },
  areaServed: [
    { "@type": "City", name: "West Melbourne" },
    { "@type": "City", name: "East Melbourne" },
    { "@type": "City", name: "North Melbourne" },
  ],
  contactPoint: {
    "@type": "ContactPoint",
    telephone: BUSINESS.phoneRaw,
    contactType: "customer service",
    areaServed: "AU",
    availableLanguage: "English",
  },
  openingHoursSpecification: [
    {
      "@type": "OpeningHoursSpecification",
      dayOfWeek: ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday"],
      opens: "09:00",
      closes: "16:30",
    },
  ],
});

export const cleaningServiceSchema = (service) => ({
  "@context": "https://schema.org",
  "@type": "Service",
  serviceType: service.title,
  provider: { "@type": "LocalBusiness", name: BUSINESS.name, telephone: BUSINESS.phoneRaw },
  areaServed: { "@type": "City", name: "Melbourne" },
  description: service.long,
});

export const faqSchema = (faqs) => ({
  "@context": "https://schema.org",
  "@type": "FAQPage",
  mainEntity: faqs.map((f) => ({
    "@type": "Question",
    name: f.q,
    acceptedAnswer: { "@type": "Answer", text: f.a },
  })),
});

export const breadcrumbSchema = (items) => ({
  "@context": "https://schema.org",
  "@type": "BreadcrumbList",
  itemListElement: items.map((it, i) => ({
    "@type": "ListItem",
    position: i + 1,
    name: it.name,
    item: `${ORIGIN}${it.path}`,
  })),
});
